import React from 'react'
import { FiPhone, FiMapPin, FiMail, FiGlobe } from 'react-icons/fi'
import { AboutFeatureItem } from './aboutFeatureItem';
import { AboutItem } from './aboutItem';
import { aboutFeatureList } from './mock';


export const AboutFeature = ({user}) => {
    const { profile } = {}
    
    return ( // !user?.phone || !user?.email ? (<React.Fragment></React.Fragment>)  : 
        <div className="about-feature">
            <ul>
                
                {profile?.languages && <AboutFeatureItem name={profile?.languages}  symbol={<FiGlobe />}  />}
                {user?.phone && <AboutItem name={user?.phone} symbol={<FiPhone />} description="Business" />}
                {user?.email && <AboutItem name={user?.email} symbol={<FiMail />} description="Business" />}
                {user?.address && <AboutItem name={user?.address} symbol={<FiMapPin />} description="" />}
                {/**
                {user?.slug && <AboutItem name={`@${user?.slug}`} avatar={user?.avatar} symbol={<FiUser />} />}
                {user?.name && user?.avatar && <AboutItem name={user?.name}  />}
               
            **/}
             {aboutFeatureList.map((item,i)=>(
                    <AboutFeatureItem item={item} key={'about'+i} />
                ))}

            </ul>
        </div>
    );
} 